export default __webpack_public_path__ + "static/media/empty_box.f6565797.png";